export const USER_STATUS_STORE = 'USER_STATUS_STORE';
export const USER_STATUS_UPDATE = 'USER_STATUS_UPDATE';
export const USER_STATUS_DESTROY = 'USER_STATUS_DESTROY';
